<template>
  <div class="alert alert-danger fade show" role="alert" v-if="error">
    <div class="alert-icon"><i class="bx bx-alert-triangle"></i></div>
    <div class="alert-text">{{ error }}</div>
    <div class="alert-close">
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
        @click="$emit('close')"
      >
        <span aria-hidden="true"><i class="bx bx-x"></i></span>
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  error: string | undefined
}>()
</script>
